import { ossSignature,ossUploadFile } from "../service";

type Files = File | Blob

function getOssSignature (file:Files, insert = function () {
}) {
    return new Promise((resolve, reject) => {
        ossSignature().then(res => {
            if (res.code === 1) {
                uploadImage(file, res.data, insert, resolve)
            } else {
                reject(res)
            }
        }).catch(e => {
            reject(e)
            // console.log(e)
        })
    })
}

export interface OssData{
    key:string,
    host:string,
    directory:string,
    policy:string,
    accessKey:string,
    signature:string
}

function uploadImage (file:Files, oss:OssData, insert:Function, resolve:Function) {
    const key = oss.key
    const url = oss.host
    // @ts-ignore
    const suffix = file.name ? file.name.slice(file.name.lastIndexOf('.')) : '.jpg'
    const formData = new FormData()

    formData.append('key', oss.directory + key + suffix)
    formData.append('policy', oss.policy)
    formData.append('OSSAccessKeyId', oss.accessKey)
    formData.append('success_action_status', '200')
    formData.append('signature', oss.signature)
    formData.append('file', file)

    // console.log(url)

    ossUploadFile({
        url,
        body:formData
    }).then(() => {
        const res = {
            code:1,
            data:url + '/' + oss.directory + key + suffix
        }
        insert(res.data)
        resolve(res)
    }).catch(() => {
        let res = {
            code:0,
            msg:'上传失败'
        }
        resolve(res)
    })
}

const ossUpload = getOssSignature

export default ossUpload
